var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_126_1068)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.0001,
    width: 70,
    height: 48,
    rx: 15.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6113 36.284L54.0554 37.0471V34.1642L57.6113 33.4152V36.284ZM43.1602 35.0544L39.7035 35.7893L39.6893 47.1091C39.6893 49.2006 41.2618 50.741 43.3585 50.741C44.5202 50.741 45.3702 50.5291 45.8377 50.2747V47.4059C45.3844 47.5896 43.146 48.2397 43.146 46.1481V41.1312H45.8377V38.1211H43.146L43.1602 35.0544ZM62.2293 38.9831C62.7251 38.5309 63.6176 37.8808 65.006 37.8808C67.4852 37.8808 69.8227 40.1137 69.8368 44.212C69.8368 48.6919 67.5277 50.7269 64.9918 50.7269C63.7451 50.7269 62.9943 50.204 62.4843 49.8366L62.4701 53.8359L58.9285 54.5849V38.1069H62.0451L62.2293 38.9831ZM62.4852 46.9535C62.8252 47.321 63.321 47.6177 64.1568 47.6177C65.4602 47.6177 66.3385 46.2045 66.3385 44.3108C66.3385 42.4595 65.446 41.0181 64.1568 41.0181C63.3493 41.0181 62.8393 41.3007 62.471 41.7105L62.4852 46.9535ZM80.9985 44.3533C80.9985 40.7355 79.2419 37.8808 75.8844 37.8808C72.5127 37.8808 70.4727 40.7355 70.4727 44.3251C70.4727 48.5788 72.881 50.7269 76.3377 50.7269C78.0235 50.7269 79.2985 50.3453 80.2619 49.8083V46.9819C79.2985 47.4624 78.1935 47.7591 76.791 47.7591C75.4169 47.7591 74.1985 47.2787 74.0427 45.6111H80.9702C80.9702 45.5332 80.9753 45.3563 80.9812 45.1525V45.1524V45.1524V45.1524C80.9891 44.8754 80.9985 44.5487 80.9985 44.3533ZM73.9996 43.0108C73.9996 41.4139 74.9771 40.7497 75.8696 40.7497C76.7338 40.7497 77.6546 41.4139 77.6546 43.0108H73.9996ZM34.7884 40.9476C34.0375 40.9476 33.5842 41.1596 33.5842 41.7108C33.5842 42.3125 34.3644 42.5772 35.3323 42.9057C36.9102 43.441 38.9871 44.1457 38.9959 46.7559C38.9959 49.2856 36.97 50.7412 34.0234 50.7412C32.805 50.7412 31.4733 50.5009 30.1558 49.9356V46.5722C31.3458 47.2223 32.8475 47.7028 34.0234 47.7028C34.8167 47.7028 35.3834 47.4908 35.3834 46.8407C35.3834 46.1741 34.5376 45.8695 33.5166 45.5016C31.9616 44.9415 30 44.2348 30 41.8804C30 39.379 31.9125 37.881 34.7884 37.881C35.9642 37.881 37.1259 38.0647 38.3017 38.5311V41.8521C37.225 41.2727 35.865 40.9476 34.7884 40.9476ZM50.2443 39.167L50.0176 38.1212H46.9576V50.4868H50.4993V42.1064C51.3351 41.0183 52.7518 41.2161 53.191 41.3716V38.1212C52.7376 37.9516 51.0801 37.6407 50.2443 39.167ZM54.0554 38.1211H57.6113V50.4867H54.0554V38.1211Z",
    fill: "#6461FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_126_1068",
    x: 0,
    y: 0.00012207,
    width: 110,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_1068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_1068",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.b6ec9af548cff0743c0ebe5945909604.svg";
export { ForwardRef as ReactComponent };